import {useIntl} from 'react-intl'
import {STATUS} from '../constants'
import {StatusType} from '../types/DetailTypes'

type StatusBadgeProps = {
  status: StatusType | undefined
}

const StatusBadge = ({status}: StatusBadgeProps) => {
  const intl = useIntl()
  return (
    <div className='row mb-4'>
      <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({id: 'STATUS'})}</label>
      <div className='col-lg-8'>
        <span
          className={`badge ${
            status === STATUS.ACTIVE ? 'badge-light-success' : 'badge-light-danger'
          }`}
        >
          {status === STATUS.ACTIVE
            ? intl.formatMessage({id: 'ACTIVE'})
            : intl.formatMessage({id: 'INACTIVE'})}
        </span>
      </div>
    </div>
  )
}

export {StatusBadge}
